// The default y position for the names placeholder is 14.4% of the way down from the top of the view constraint area. In a center origin system, this is a starting y position of -35.6% of the view constraint area.
export const MAX_NAMES_AND_NUMBERS_PER_SIZE = 1000;
export const NAMES_PRICE = '$5.50';
export const NUMBERS_PRICE = '$3.50';
export const NAMES_DEFAULT_Y_FACTOR = -0.3;
export const NUMBERS_DEFAULT_Y_OFFSET = 6.2;
const NAMES_DEFAULT_FONT_HEIGHT = 2;
const NUMBERS_DEFAULT_FONT_HEIGHT = 8;
export const NAME_CHAR_LIMIT = 46;
export const NUMBER_CHAR_LIMIT = 14;
export const NAMES_FONT_HEIGHTS = [1, NAMES_DEFAULT_FONT_HEIGHT];
export const NUMBERS_FONT_HEIGHTS = [2, 4, 6, NUMBERS_DEFAULT_FONT_HEIGHT];
